import React, { Component } from "react";
import { NavLink, withRouter } from "react-router-dom";
import Button from "@material-ui/core/Button";

import IntlMessages from "util/IntlMessages";
import CustomScrollbars from "util/CustomScrollbars";
import SupervisedUserCircleTwoToneIcon from "@material-ui/icons/SupervisedUserCircleTwoTone";

class AdminMenuList extends Component {
  componentDidMount() {
    const { history } = this.props;
    const that = this;
    const pathname = `${history.location.pathname}`; // get current path

    const menuLi = document.getElementsByClassName("menu");
    for (let i = 0; i < menuLi.length; i++) {
      menuLi[i].onclick = function(event) {
        for (let j = 0; j < menuLi.length; j++) {
          const parentLi = that.closest(this, "li");
          if (
            menuLi[j] !== this &&
            (parentLi === null || !parentLi.classList.contains("open"))
          ) {
            if (
              !menuLi[j].classList.contains("sub") &&
              this.closest(".menu").classList.contains("open") === false
            ) {
              menuLi[j].classList.remove("open");
            }
          }
        }
        this.classList.toggle("open");
      };
    }

    const activeLi = document.querySelector('a[href="' + pathname + '"]'); // select current a element
    try {
      const activeNav = this.closest(activeLi, "ul"); // select closest ul
      if (activeNav.classList.contains("sub-menu")) {
        this.closest(activeNav, "li").classList.add("open");
      } else {
        this.closest(activeLi, "li").classList.add("open");
      }
    } catch (error) {}
  }

  componentWillReceiveProps(nextProps) {
    const { history } = nextProps;
    const pathname = `${history.location.pathname}`; // get current path

    const activeLi = document.querySelector('a[href="' + pathname + '"]'); // select current a element
    try {
      const activeNav = this.closest(activeLi, "ul"); // select closest ul
      if (activeNav.classList.contains("sub-menu")) {
        this.closest(activeNav, "li").classList.add("open");
      } else {
        this.closest(activeLi, "li").classList.add("open");
      }
    } catch (error) {}
  }

  closest(el, selector) {
    try {
      let matchesFn;
      // find vendor prefix
      [
        "matches",
        "webkitMatchesSelector",
        "mozMatchesSelector",
        "msMatchesSelector",
        "oMatchesSelector",
      ].some(function(fn) {
        if (typeof document.body[fn] == "function") {
          matchesFn = fn;
          return true;
        }
        return false;
      });

      let parent;

      // traverse parents
      while (el) {
        parent = el.parentElement;
        if (parent && parent[matchesFn](selector)) {
          return parent;
        }
        el = parent;
      }
    } catch (e) {}

    return null;
  }

  //function to group objects in an array based on key value
  groupBy = (objectArray, property) => {
    return objectArray.reduce((acc, obj) => {
      const key = obj[property];
      if (!acc[key]) {
        acc[key] = [];
      }
      // Add object to list for given key's value
      acc[key].push(obj);
      return acc;
    }, []);
  };

  render() {
    const { pages } = this.props;
    //group pages
    const result = this.groupBy(pages, "Menu_Id");
    // return (
    //   <CustomScrollbars className=" scrollbar">
    //     <ul className="nav-menu">
    //       <li className="nav-header">
    //         <IntlMessages id="sidebar.menu" />
    //       </li>

    //       <li className="menu no-arrow">
    //         <NavLink to="/admin/dashboard">
    //           <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
    //           <span className="nav-text">Home</span>
    //         </NavLink>
    //       </li>

    //       {Object.keys(result).map((key) => {
    //         {
    //           {
    //             /* const randomColor = Math.floor(Math.random()*16777215).toString(16); */
    //           }
    //         }
    //         return (
    //           <li className="menu">
    //             <Button className="void">
    //               <i
    //                 className={`zmdi ${result[key][0].Menu_Icon} zmdi-hc-fw`}
    //               />
    //               <span className="nav-text">{result[key][0].Menu_Name}</span>
    //             </Button>
    //             <ul className="sub-menu">
    //               {result[key].map((dataItem, k) => {
    //                 {
    //                 }
    //                 return (
    //                   <li key={k}>
    //                     <NavLink
    //                       className="prepend-icon"
    //                       to={dataItem.Page.replace(/[^a-zA-Z]/g, "")}
    //                     >
    //                       <span className="nav-text">
    //                         {dataItem.Page == "AddEditCourses"
    //                           ? "Add/Edit Courses"
    //                           : dataItem.Page}
    //                       </span>
    //                     </NavLink>
    //                   </li>
    //                 );
    //               })}
    //             </ul>
    //           </li>
    //         );
    //       })}

    //       {/* <li className="menu">
    //         <Button className="void">
    //           {/* <i className="zmdi zmdi-accounts-list zmdi-hc-fw" /> */}
    //       {/* <i>
    //             <SupervisedUserCircleTwoToneIcon fontSize="small" />
    //           </i>
    //           <span className="nav-text">User Access</span>
    //         </Button>

    //         <ul className="sub-menu">
    //           <li>
    //             <NavLink className="prepend-icon" to="/admin/useraccess/roles">
    //               <span className="nav-text">Roles</span>
    //             </NavLink>
    //           </li>
    //           <li>
    //             <NavLink
    //               className="prepend-icon"
    //               to="/admin/useraccess/administrators"
    //             >
    //               <span className="nav-text">Administrators</span>
    //             </NavLink>
    //           </li>
    //           <li>
    //             <NavLink className="prepend-icon" to="/admin/useraccess/audits">
    //               <span className="nav-text">Audit Trail</span>
    //             </NavLink>
    //           </li>
    //         </ul>
    //       </li>

    //       <li className="menu">
    //         <Button className="void">
    //           <i className="zmdi zmdi zmdi-settings zmdi-hc-fw" />
    //           <span className="nav-text">Setup</span>
    //         </Button>

    //         <ul className="sub-menu">
    //           <li>
    //             <NavLink className="prepend-icon" to="/admin/setup/information">
    //               <span className="nav-text">School Information</span>
    //             </NavLink>
    //           </li>
    //           <li>
    //             <NavLink className="prepend-icon" to="/admin/setup/settings">
    //               <span className="nav-text">School Settings</span>
    //             </NavLink>
    //           </li>
    //           <li>
    //             <NavLink className="prepend-icon" to="/admin/setup/semesters">
    //               <span className="nav-text">Manage Semesters</span>
    //             </NavLink>
    //           </li>
    //           <li>
    //             <NavLink className="prepend-icon" to="/admin/setup/levels">
    //               <span className="nav-text">Manage Levels</span>
    //             </NavLink>
    //           </li>
    //           <li>
    //             <NavLink className="prepend-icon" to="/admin/setup/degree">
    //               <span className="nav-text">Manage Class of Degree</span>
    //             </NavLink>
    //           </li>
    //           <li>
    //             <NavLink className="prepend-icon" to="/admin/setup/scoregrades">
    //               <span className="nav-text">Manage Score Grades</span>
    //             </NavLink>
    //           </li>
    //           <li>
    //             <NavLink
    //               className="prepend-icon"
    //               to="/admin/setup/qualifications"
    //             >
    //               <span className="nav-text">Manage Qualifications</span>
    //             </NavLink>
    //           </li>
    //           <li>
    //             <NavLink className="prepend-icon" to="/admin/setup/grades">
    //               <span className="nav-text">Manage Grades</span>
    //             </NavLink>
    //           </li>
    //           <li>
    //             <NavLink className="prepend-icon" to="/admin/setup/colleges">
    //               <span className="nav-text">Manage Colleges</span>
    //             </NavLink>
    //           </li>
    //           <li>
    //             <NavLink className="prepend-icon" to="/admin/setup/departments">
    //               <span className="nav-text">Manage Departments</span>
    //             </NavLink>
    //           </li>
    //           <li>
    //             <NavLink className="prepend-icon" to="/admin/setup/schoolunits">
    //               <span className="nav-text">Manage School Units</span>
    //             </NavLink>
    //           </li>
    //           <li>
    //             <NavLink
    //               className="prepend-icon"
    //               to="/admin/setup/departmenttuition"
    //             >
    //               <span className="nav-text">Department Tuition</span>
    //             </NavLink>
    //           </li>
    //           <li>
    //             <NavLink
    //               className="prepend-icon"
    //               to="/admin/setup/matricnumber"
    //             >
    //               <span className="nav-text">Setup Matric Number</span>
    //             </NavLink>
    //           </li>
    //           <li>
    //             <NavLink className="prepend-icon" to="/admin/setup/payments">
    //               <span className="nav-text">Manage Payments</span>
    //             </NavLink>
    //           </li>
    //         </ul>
    //       </li>

    //       <li className="menu">
    //         <Button className="void">
    //           <i className="zmdi zmdi-accounts-list zmdi-hc-fw" />
    //           <span className="nav-text">Applications</span>
    //         </Button>

    //         <ul className="sub-menu">
    //           <li>
    //             <NavLink
    //               className="prepend-icon"
    //               to="/admin/application/inprogress"
    //             >
    //               <span className="nav-text">In Progress</span>
    //             </NavLink>
    //           </li>

    //           <li>
    //             <NavLink
    //               className="prepend-icon"
    //               to="/admin/application/completed"
    //             >
    //               <span className="nav-text">Completed</span>
    //             </NavLink>
    //           </li>

    //           {/* <li>
    //             <NavLink
    //               className="prepend-icon"
    //               to="/admin/application/rejected"
    //             >
    //               <span className="nav-text">Rejected</span>
    //             </NavLink>
    //           </li>
    //         </ul>
    //       </li> */}
    //       {/*
    //       <li className="menu">
    //         <Button className="void">
    //           <i className="zmdi zmdi-accounts-list zmdi-hc-fw" />
    //           <span className="nav-text">Students</span>
    //         </Button>

    //         <ul className="sub-menu">
    //           <li>
    //             <NavLink className="prepend-icon" to="/admin/students/students">
    //               <span className="nav-text">Student</span>
    //             </NavLink>
    //           </li>
    //         </ul>
    //       </li>

    //       <li className="menu">
    //         <Button className="void">
    //           <i className="zmdi zmdi-accounts-list zmdi-hc-fw" />
    //           <span className="nav-text">Staffs</span>
    //         </Button>

    //         <ul className="sub-menu">
    //           <li>
    //             <NavLink className="prepend-icon" to="/admin/staffs/staffs">
    //               <span className="nav-text">Staffs</span>
    //             </NavLink>
    //           </li>
    //         </ul>
    //       </li>

    //       <li className="menu">
    //         <Button className="void">
    //           <i className="zmdi zmdi-card zmdi-hc-fw" />
    //           <span className="nav-text">Payments</span>
    //         </Button>

    //         <ul className="sub-menu">
    //           <li>
    //             <NavLink
    //               className="prepend-icon"
    //               to="/admin/payments/applications"
    //             >
    //               <span className="nav-text">Applications</span>
    //             </NavLink>
    //           </li>
    //         </ul>
    //       </li>

    //       <li className="menu">
    //         <Button className="void">
    //           <i className="zmdi zmdi zmdi-folder-person zmdi-hc-fw" />
    //           <span className="nav-text">Administration</span>
    //         </Button>

    //         <ul className="sub-menu">
    //           <li>
    //             <NavLink
    //               className="prepend-icon"
    //               to="/admin/administration/sessions"
    //             >
    //               <span className="nav-text">Academic Session</span>
    //             </NavLink>
    //           </li>
    //           <li>
    //             <NavLink
    //               className="prepend-icon"
    //               to="/admin/administration/semesters"
    //             >
    //               <span className="nav-text">Semester Registration</span>
    //             </NavLink>
    //           </li>
    //           <li>
    //             <NavLink
    //               className="prepend-icon"
    //               to="/admin/administration/officials"
    //             >
    //               <span className="nav-text">Manage School Officials</span>
    //             </NavLink>
    //           </li>
    //           <li>
    //             <NavLink
    //               className="prepend-icon"
    //               to="/admin/administration/payments"
    //             >
    //               <span className="nav-text">Manage Student Payments</span>
    //             </NavLink>
    //           </li>
    //         </ul>
    //       </li>
    //       </li>

    //        <li className="menu">
    //         <Button className="void">
    //           <i className="zmdi zmdi-accounts-add zmdi-hc-fw" />
    //           <span className="nav-text">Admission</span>
    //         </Button>

    //         <ul className="sub-menu">
    //           <li>
    //             <NavLink className="prepend-icon" to="/admin/admissions/approved">
    //               <span className="nav-text">Approve Applications</span>
    //             </NavLink>
    //           </li>
    //           <li>
    //             <NavLink className="prepend-icon" to="/admin/admissions/verified">
    //               <span className="nav-text">Verify Applications</span>
    //             </NavLink>
    //           </li>
    //           <li>
    //             <NavLink className="prepend-icon" to="/admin/admissions/confirmed">
    //               <span className="nav-text">Confirm Applications</span>
    //             </NavLink>
    //           </li>
    //           <li>
    //             <NavLink className="prepend-icon" to="/admin/admission/reject">
    //               <span className="nav-text">Rejected List</span>
    //             </NavLink>
    //           </li>
    //           <li>
    //             <NavLink
    //               className="prepend-icon"
    //               to="/admin/admissions/allapplications"
    //             >
    //               <span className="nav-text">All Applications</span>
    //             </NavLink>
    //           </li>
    //            <li>
    //             <NavLink
    //               className="prepend-icon"
    //               to="/admin/setup/programme"
    //             >
    //               <span className="nav-text">Admission Programme</span>
    //             </NavLink>
    //           </li>
    //           <li>
    //             <NavLink className="prepend-icon" to="/admin/admission/session">
    //               <span className="nav-text">Admission Session</span>
    //             </NavLink>
    //           </li> *
    //           <li>
    //             <NavLink
    //               className="prepend-icon"
    //               to="/admin/admission/admissionnumber"
    //             >
    //               <span className="nav-text">Set Admission Number</span>
    //             </NavLink>
    //           </li>
    //           * <li>
    //             <NavLink
    //               className="prepend-icon"
    //               to="/admin/admission/applicants"
    //             >
    //               <span className="nav-text">Applications</span>
    //             </NavLink>
    //           </li>
    //            <li>
    //             <NavLink
    //               className="prepend-icon"
    //               to="/admin/admission/information"
    //             >
    //               <span className="nav-text">Admission Information</span>
    //             </NavLink>
    //           </li>
    //           <li>
    //             <NavLink
    //               className="prepend-icon"
    //               to="/admin/admission/documents"
    //             >
    //               <span className="nav-text">Admission Documents</span>
    //             </NavLink>
    //           </li>
    //           <li>
    //             <NavLink
    //               className="prepend-icon"
    //               to="/admin/admission/payments"
    //             >
    //               <span className="nav-text">Applicant Payment</span>
    //             </NavLink>
    //           </li>
    //           <li>
    //             <NavLink className="prepend-icon" to="/admin/admission/export">
    //               <span className="nav-text">Export Admitted</span>
    //             </NavLink>
    //           </li>
    //         </ul>
    //       </li>

    //       <li className="menu">
    //         <Button className="void">
    //           <i className="zmdi zmdi-card zmdi-hc-fw" />
    //           <span className="nav-text">Payments</span>
    //         </Button>

    //         <ul className="sub-menu">
    //           <li>
    //             <NavLink
    //               className="prepend-icon"
    //               to="/admin/payments/applications"
    //             >
    //               <span className="nav-text">Applications</span>
    //             </NavLink>
    //           </li>
    //         </ul>
    //       </li>

    //       <li className="menu">
    //         <Button className="void">
    //           <i className="zmdi zmdi zmdi-folder-person zmdi-hc-fw" />
    //           <span className="nav-text">Administration</span>
    //         </Button>

    //         <ul className="sub-menu">
    //           <li>
    //             <NavLink
    //               className="prepend-icon"
    //               to="/admin/administration/staffs"
    //             >
    //               <span className="nav-text">Staffs</span>
    //             </NavLink>
    //           </li>
    //           <li>
    //             <NavLink
    //               className="prepend-icon"
    //               to="/admin/administration/students"
    //             >
    //               <span className="nav-text">Students</span>
    //             </NavLink>
    //           </li>
    //           <li>
    //             <NavLink
    //               className="prepend-icon"
    //               to="/admin/administration/sessions"
    //             >
    //               <span className="nav-text">Academic Session</span>
    //             </NavLink>
    //           </li>
    //           <li>
    //             <NavLink
    //               className="prepend-icon"
    //               to="/admin/administration/semesters"
    //             >
    //               <span className="nav-text">Semester Registration</span>
    //             </NavLink>
    //           </li>
    //           <li>
    //             <NavLink
    //               className="prepend-icon"
    //               to="/admin/administration/officials"
    //             >
    //               <span className="nav-text">Manage School Officials</span>
    //             </NavLink>
    //           </li>
    //           <li>
    //             <NavLink
    //               className="prepend-icon"
    //               to="/admin/administration/payments"
    //             >
    //               <span className="nav-text">Manage Student Payments</span>
    //             </NavLink>
    //           </li>
    //         </ul>
    //       </li>

    //       <li className="menu">
    //         <Button className="void">
    //           <i className="zmdi zmdi-book zmdi-hc-fw" />
    //           <span className="nav-text">Courses</span>
    //         </Button>
    //         <ul className="sub-menu">
    //           <li>
    //             <NavLink className="prepend-icon" to="/admin/courses/courses">
    //               <span className="nav-text">Courses</span>
    //             </NavLink>
    //           </li>
    //           <li>
    //             <NavLink
    //               className="prepend-icon"
    //               to="/admin/courses/CoreCourses"
    //             >
    //               <span className="nav-text">Core Courses</span>
    //             </NavLink>
    //           </li>
    //           <li>
    //             <NavLink
    //               className="prepend-icon"
    //               to="/admin/courses/PrerequisiteCourses"
    //             >
    //               <span className="nav-text">Prerequisite Courses</span>
    //             </NavLink>
    //           </li>
    //           <li>
    //             <NavLink
    //               className="prepend-icon"
    //               to="/admin/courses/CourseLecturers"
    //             >
    //               <span className="nav-text">Course Lecturers</span>
    //             </NavLink>
    //           </li>
    //           <li>
    //             <NavLink
    //               className="prepend-icon"
    //               to="/admin/courses/RegistrationLimit"
    //             >
    //               <span className="nav-text">Dept Registration Limit</span>
    //             </NavLink>
    //           </li>
    //           {/* <li>
    //             <NavLink
    //               className="prepend-icon"
    //               to="/admin/courses/uploadCourse"
    //             >
    //               <span className="nav-text">Upload Course Registration</span>
    //             </NavLink>
    //           </li>
    //         </ul>
    //       </li>

    //       {/* <li className="menu">
    //         <Button>
    //           <i className="zmdi zmdi-device-hub zmdi-hc-fw" />
    //           <span className="nav-text">
    //             <IntlMessages id="sidebar.menuLevels" />
    //           </span>
    //         </Button>

    //         <ul className="sub-menu">
    //           <li>
    //             <Button className="prepend-icon">
    //               <span className="nav-text">
    //                 <IntlMessages id="sidebar.menuLevels.level1" />
    //               </span>
    //             </Button>
    //           </li>
    //           <li className="menu sub">
    //             <Button className="prepend-icon">
    //               <span className="nav-text">
    //                 <IntlMessages id="sidebar.menuLevels.level1" />
    //               </span>
    //             </Button>

    //             <ul className="sub-menu">
    //               <li>
    //                 <Button href="">
    //                   <span className="nav-text">
    //                     <IntlMessages id="sidebar.menuLevels.level2" />
    //                   </span>
    //                 </Button>
    //               </li>
    //               <li className="menu sub">
    //                 <Button href="">
    //                   <span className="nav-text">
    //                     <IntlMessages id="sidebar.menuLevels.level2" />
    //                   </span>
    //                 </Button>

    //                 <ul className="sub-menu">
    //                   <li>
    //                     <Button href="">
    //                       <span className="nav-text">
    //                         <IntlMessages id="sidebar.menuLevels.level3" />
    //                       </span>
    //                     </Button>
    //                   </li>
    //                   <li>
    //                     <Button href="">
    //                       <span className="nav-text">
    //                         <IntlMessages id="sidebar.menuLevels.level3" />
    //                       </span>
    //                     </Button>
    //                   </li>
    //                 </ul>
    //               </li>
    //             </ul>
    //           </li>
    //         </ul>
    //       </li> */}
    //       <li className="menu no-arrow">
    //         <NavLink to="/admin/changepassword">
    //           <i className="zmdi zmdi-key zmdi-hc-fw" />
    //           <span className="nav-text">Change Password</span>
    //         </NavLink>
    //       </li>
    //     </ul>
    //   </CustomScrollbars>
    // );

    return (
      <CustomScrollbars className=" scrollbar">
        <ul className="nav-menu">
          <li className="nav-header">
            <IntlMessages id="sidebar.menu" />
          </li>

          <li className="menu no-arrow">
            <NavLink to="/admin/dashboard">
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
              <span className="nav-text">Home</span>
            </NavLink>
          </li>

          {Object.keys(result).map((key) => (
            <li className="menu" key={key}>
              <Button className="void">
                <i className={`zmdi ${result[key][0].Menu_Icon} zmdi-hc-fw`} />
                <span className="nav-text">{result[key][0].Menu_Name}</span>
              </Button>
              <ul className="sub-menu">
                {result[key].map((dataItem, k) => (
                  <li key={k}>
                    <NavLink
                      className="prepend-icon"
                      to={dataItem.Page.replace(/[^a-zA-Z]/g, "")}
                    >
                      <span className="nav-text">
                        {dataItem.Page === "AddEditCourses"
                          ? "Add/Edit Courses"
                          : dataItem.Page}
                      </span>
                    </NavLink>
                  </li>
                ))}
              </ul>
            </li>
          ))}

          <li className="menu no-arrow">
            <NavLink to="/admin/changepassword">
              <i className="zmdi zmdi-key zmdi-hc-fw" />
              <span className="nav-text">Change Password</span>
            </NavLink>
          </li>
        </ul>
      </CustomScrollbars>

      // <CustomScrollbars className="scrollbar">
      //   <ul className="nav-menu">
      //     <li className="nav-header">
      //       <IntlMessages id="sidebar.menu" />
      //     </li>

      //     <li className="menu no-arrow">
      //       <NavLink to="/admin/dashboard">
      //         <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
      //         <span className="nav-text">Home</span>
      //       </NavLink>
      //     </li>

      //     {[
      //       {
      //         items: [
      //           {
      //             Page_Id: 1,
      //             Page: "Roles",
      //             PageLink: "useraccess/roles",
      //             Menu_Id: 2,
      //             Menu_Name: "User Access",
      //             Menu_Icon: "zmdi-accounts-list",
      //             subMenuL: null,
      //           },
      //           {
      //             Page_Id: 1,
      //             Menu_Id: 2,
      //             Menu_Name: "User Access",
      //             Page: "Administrators",
      //             PageLink: "useraccess/administrators",
      //             Menu_Icon: "zmdi-accounts-list",
      //             subMenuL: null,
      //           },
      //         ],
      //       },
      //       {
      //         items: [
      //           {
      //             Page_Id: 18,
      //             Page: "In Progress",
      //             PageLink: "application/inprogress",
      //             Menu_Id: 4,
      //             Menu_Name: "Applications",
      //             Menu_Icon: "zmdi-accounts-list",
      //             subMenuL: null,
      //           },
      //           {
      //             Page_Id: 19,
      //             Page: "Completed",
      //             PageLink: "application/completed",
      //             Menu_Id: 4,
      //             Menu_Name: "Applications",
      //             Menu_Icon: "zmdi-accounts-list",
      //             subMenuL: null,
      //           },
      //         ],
      //       },
      //       {
      //         items: [
      //           {
      //             Page_Id: 11,
      //             Page: "Post Utme List",
      //             PageLink: "admission/postutmelist",
      //             Menu_Id: 5,
      //             Menu_Name: "Admission",
      //             Menu_Icon: "zmdi-accounts-add",
      //             subMenuL: null,
      //           },
      //           {
      //             Page_Id: 20,
      //             Page: "Screen Admission",
      //             PageLink: "admission/approve",
      //             Menu_Id: 5,
      //             Menu_Name: "Admission",
      //             Menu_Icon: "zmdi-accounts-add",
      //             subMenuL: null,
      //           },
      //           // {
      //           //   Page_Id: 21,
      //           //   Page: "Verify Admission",
      //           //   PageLink: "admission/verify",
      //           //   Menu_Id: 5,
      //           //   Menu_Name: "Admission",
      //           //   Menu_Icon: "zmdi-accounts-add",
      //           //   subMenuL: null,
      //           // },
      //           // {
      //           //   Page_Id: 22,
      //           //   Page: "Confirm Admission",
      //           //   PageLink: "admission/confirm",
      //           //   Menu_Id: 5,
      //           //   Menu_Name: "Admission",
      //           //   Menu_Icon: "zmdi-accounts-add",
      //           //   subMenuL: null,
      //           // },
      //           // {
      //           //   Page_Id: 23,
      //           //   Page: "screening report",
      //           //   PageLink: "admission/screeningreport",
      //           //   Menu_Id: 5,
      //           //   Menu_Name: "Admission",
      //           //   Menu_Icon: "zmdi-accounts-add",
      //           //   subMenuL: null,
      //           // },
      //           // {
      //           //   Page_Id: 25,
      //           //   Page: "All Applications",
      //           //   PageLink: "admission/allapplications",
      //           //   Menu_Id: 5,
      //           //   Menu_Name: "Admission",
      //           //   Menu_Icon: "zmdi-accounts-add",
      //           //   subMenuL: null,
      //           // },
      //           // {
      //           //   Page_Id: 42,
      //           //   Page: "Admission Document",
      //           //   PageLink: "setup/managedocument",
      //           //   Menu_Id: 5,
      //           //   Menu_Name: "Admission",
      //           //   Menu_Icon: "zmdi-accounts-add",
      //           //   subMenuL: null,
      //           // },
      //         ],
      //       },
      //       {
      //         items: [
      //           {
      //             Menu_Icon: "zmdi-folder-person",
      //             Menu_Id: 8,
      //             Menu_Name: "Administration",
      //             Page: "Setup Courses",
      //             PageLink: "courses/courses",
      //             Page_Id: 35,
      //             subMenuL: null,
      //           },
      //         ],
      //       },
      //       {
      //         items: [
      //           {
      //             Page_Id: 26,
      //             Page: "Payment History",
      //             PageLink: "payments/paymenthistory",
      //             Menu_Id: 7,
      //             Menu_Name: "Payments",
      //             Menu_Icon: "zmdi-card",
      //             subMenuL: null,
      //           },
      //         ],
      //       },
      //     ].map((section, index) => (
      //       <li className="menu" key={index}>
      //         <Button className="void">
      //           <i
      //             className={`zmdi ${section.items[0].Menu_Icon} zmdi-hc-fw`}
      //           />
      //           <span className="nav-text">{section.items[0].Menu_Name}</span>
      //         </Button>
      //         <ul className="sub-menu">
      //           {section.items.map((item, itemIndex) => (
      //             <li key={itemIndex}>
      //               <NavLink
      //                 className="prepend-icon"
      //                 to={item.Page.replace(/[^a-zA-Z]/g, "")}
      //               >
      //                 <span className="nav-text">
      //                   {item.Page === "AddEditCourses"
      //                     ? "Add/Edit Courses"
      //                     : item.Page}
      //                 </span>
      //               </NavLink>
      //             </li>
      //           ))}
      //         </ul>
      //       </li>
      //     ))}

      //     <li className="menu no-arrow">
      //       <NavLink to="/admin/changepassword">
      //         <i className="zmdi zmdi-key zmdi-hc-fw" />
      //         <span className="nav-text">Change Password</span>
      //       </NavLink>
      //     </li>
      //   </ul>
      // </CustomScrollbars>
    );
  }
}

export default withRouter(AdminMenuList);
